import { Heading, Text } from "@sentricmusic/ui";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";

import BroadcastsTable from "./BroadcastsTable";

function Broadcasts() {
  const { t } = useTranslation();

  const { data: siteConfig } = useSiteConfigAuth();
  const navigate = useNavigate();
  const noBroadcasts = siteConfig?.disable_broadcasts;
  useEffect(() => {
    if (noBroadcasts) {
      void navigate({ to: "/" });
    }
  }, [noBroadcasts, navigate]);

  return (
    <div className="flex-1 order-last xl:w-full bg-layer-raised min-h-50 lg:min-h-screen-minus-header">
      <Heading as="h3">{t("other:your-broadcasts-header", "Your Broadcasts")}</Heading>
      <Text className="font-sentric-alt mb-8 ">
        {t("other:your-broadcasts-text", "If you know one of your songs has been broadcast on either Radio or TV then add the details below. We'll use the information to ensure the society pays out any royalties owed as quickly as possible.")}
      </Text>
      <BroadcastsTable />
    </div>
  );
}
export default Broadcasts;
